// theme.config.js
export const userThemes = {
    // Extensions pour le thème light existant
    light: {
        "--theme-white": "#FFFFFF",
        "--theme-mirage": "#070B0E",
        "--theme-peach": "#FFBF99",
        "--theme-broom": "#FEE715",
        // Ajoutez autant de propriétés que vous voulez
        "--theme-bg": "#ffffff",
        "--theme-text": "#1f2937",
        "--theme-border": "#e5e7eb",
        "--theme-card-bg": "#f9fafb",
        "--theme-primary": "#0B63F3",
        "--theme-hover": "#f3f4f6",
        "--theme-muted": "#6b7280",
        "--theme-info-bg": "#eff6ff",
        "--theme-info-border": "#bfdbfe",
        "--theme-highlight-bg": "#fef3c7",
        "--theme-highlight-border": "#fde68a",
    },

    // Extensions pour le thème dark existant
    dark: {
        "--theme-mirage": "#070B0E",
        "--theme-peach": "#FFBF99",
        "--theme-broom": "#FEE715",
        //Autres
        "--theme-bg": "#1f2937",
        "--theme-text": "#f9fafb",
        "--theme-border": "#374151",
        "--theme-card-bg": "#111827",
        "--theme-primary": "#60a5fa",
        "--theme-hover": "#374151",
        "--theme-muted": "#9ca3af",
        "--theme-info-bg": "#1e3a8a",
        "--theme-info-border": "#0B63F3",
        "--theme-highlight-bg": "#78350f",
        "--theme-highlight-border": "#f59e0b",
    },
};
